// src/StockHeatmapPage.js
import React from 'react';
import StockHeatmap from './componets/StockHeatmap';
import './HeatmapPage.css';

function StockHeatmapPage() {
  return (
    <div className="heatmap-page">
      <h1>Stock Market Heatmap</h1>
      <div className="heatmap-container">
        <StockHeatmap />
      </div>
    </div>
  );
}

export default StockHeatmapPage;
